<template>
  <div class='map-wrapper'>
  <GmapMap class="google-map"
    :options="{
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: true,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: true
    }"
    :center="{lat:47.7836029, lng: 35.2431865}"
    :zoom="16">
    <GmapMarker ref="myMarker" :position="google && new google.maps.LatLng(47.7836029, 35.2431865)"/>
  </GmapMap>
  </div>
</template>
<script>
import { gmapApi } from 'vue2-google-maps'

export default {
  name: 'GoogleMap',
  computed: {
    google: gmapApi
  }
}
</script>

<style lang='scss' scoped>
@import 'src/styles/_colors.scss';
@import 'src/styles/_sizes.scss';
.map-wrapper {
  border: 1px solid $primary-color;
  height: 430px;
  width: 100%;
  .google-map {
    height: 100%;
    width: 100%;
  }
}
@media (max-width: $desktop){
  .map-wrapper {
    height: 400px;
  }
}
@media (max-width: $laptop){
  .map-wrapper {
    height: 430px;
  }
}
@media (max-width: $tablet){
  .map-wrapper {
    height: 400px;
  }
}
@media (max-width: $mobile){
  .map-wrapper {
    height: 360px;
  }
}
</style>
